import React, {PureComponent} from "react"
import * as PropTypes from "prop-types"

import Recognition from "./secondaryNavContexts/Recognition"
import Medical from "./secondaryNavContexts/Medical"

interface Props {
  pathname?: string
}

class SecondaryNavContext extends PureComponent<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired,
    appPath: PropTypes.string.isRequired
  }

  static defaultProps = {
    pathname: ""
  }

  render() {
    const {pathname} = this.props
    const {apps, appPath} = this.context
    switch (appPath) {
      case apps.RECOGNITION:
        return <Recognition pathname={pathname} />
      case apps.MEDICAL:
        return <Medical pathname={pathname} />
      default:
        return null
    }
  }
}

export default SecondaryNavContext
